// extracted by mini-css-extract-plugin
export var containerTop = "layout-module--containerTop--bb318";
export var footer = "layout-module--footer--e1719";
export var mainContent = "layout-module--mainContent--5aec2";
export var siteWrapper = "layout-module--siteWrapper--e3105";
export var space = "layout-module--space--a53d3";
export var topNav = "layout-module--topNav--d3d53";
export var withSideNav = "layout-module--withSideNav--cce4b";